// The same color palette and hash logic also exists in
// packages/kenno-ui/src/services/messageCategoryColor.ts - update both.
const MESSAGE_CATEGORY_COLORS = [
  '#FFEFF2',
  '#F2CA9C',
  '#CDF0F8',
  '#ABE0D6',
  '#E7D8F4',
  '#F6D7C1',
  '#D9E7F7',
  '#E2F0C9',
  '#F3E3A8',
  '#D9D5EA',
] as const

export type MessageCategoryColor = (typeof MESSAGE_CATEGORY_COLORS)[number]

const normalizeCategoryName = (categoryName: string): string =>
  categoryName.trim().toLocaleLowerCase('fi-FI')

export const getMessageCategoryColor = (
  categoryName: string | null | undefined
): MessageCategoryColor | undefined => {
  if (!categoryName) {
    return undefined
  }

  const normalizedCategoryName = normalizeCategoryName(categoryName)
  let hash = 0

  for (const character of normalizedCategoryName) {
    hash = (hash * 31 + character.codePointAt(0)!) | 0
  }

  const colorIndex = Math.abs(hash) % MESSAGE_CATEGORY_COLORS.length
  return MESSAGE_CATEGORY_COLORS[colorIndex]
}
